import { motion } from "framer-motion";

export const easeOut = [0.22, 1, 0.36, 1];

// Fade-up on scroll into view
export function Reveal({ children, delay = 0, y = 40, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.85, ease: easeOut, delay }}
    >
      {children}
    </motion.div>
  );
}

// Masked line-by-line reveal (each line clipped, slides up)
export function MaskLine({ children, delay = 0, className = "" }) {
  return (
    <span className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block"
        initial={{ y: "110%" }}
        animate={{ y: "0%" }}
        transition={{ duration: 1, ease: easeOut, delay }}
      >
        {children}
      </motion.span>
    </span>
  );
}

export default Reveal;
